import { Globe } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import logoFull from "@/assets/logo-full-white.png";

const Footer = () => {
  const { t } = useTranslation();

  const navItems = [
    { label: t("nav.services"), href: "#servicos" },
    { label: t("nav.testimonials"), href: "#depoimentos" },
    { label: t("nav.clients"), href: "#clientes" },
    { label: t("nav.contact"), href: "#contato" },
  ];

  return (
    <footer className="relative glass border-t border-primary/10 py-16 mt-8 z-10 bg-background">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <img src={logoFull} alt="Freela Media" className="h-20" />
            <p className="mt-4 text-sm font-body text-muted-foreground max-w-xs leading-relaxed">
              {t("footer.description")}
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="text-sm font-display font-semibold text-foreground mb-4">{t("footer.navigation")}</p>
            <nav className="flex flex-col gap-3">
              {navItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className="text-sm font-body text-muted-foreground hover:text-primary transition-colors duration-150"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>
          <div className="md:col-span-4">
            <p className="text-sm font-display font-semibold text-foreground mb-4">{t("footer.contact")}</p>
            <div className="flex flex-col gap-3">
              <p className="text-sm font-body text-muted-foreground">
                contact@freelamedia.com
              </p>
              <p className="text-sm font-body text-muted-foreground flex items-center gap-1.5">
                <Globe className="w-3.5 h-3.5" />
                {t("footer.global")}
              </p>
              <span className="w-2.5 h-2.5 rounded-full bg-lime-400 shadow-[0_0_8px_hsla(82,80%,55%,0.6)] inline-block mt-1" />
              <Link
                to="/politica"
                className="text-sm font-body text-muted-foreground hover:text-primary transition-colors duration-150 mt-2"
              >
                {t("footer.privacyPolicy")}
              </Link>
              <Link
                to="/termos"
                className="text-sm font-body text-muted-foreground hover:text-primary transition-colors duration-150"
              >
                {t("footer.termsOfUse")}
              </Link>
              
            </div>
          </div>
        </div>
        <div className="gradient-line mt-12 mb-8" />
        <p className="text-xs font-body text-muted-foreground/60">
          {t("footer.rights", { year: "2016-2026" })}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
